import Vue from "vue";
import Router from "vue-router";
import HelloWorld from "@/components/HelloWorld";
import Success from "@/routes/Success";
import Error from "@/routes/Error";
import Icons from "@/routes/Icons";
import Claim from "@/routes/Claim";
import WebViewRegister from "@/routes/WebViewRegister";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "HelloWorld",
      component: HelloWorld
    },
    {
      path: "/web-view-user/:uid",
      name: "WebViewRegister",
      component: WebViewRegister
    },
    {
      path: "/claim-prize",
      name: "Claim",
      component: Claim
    },
    {
      path: "/acknowledgement",
      name: "Acknowledgement",
      component: Success
    },
    {
      path: "/error",
      name: "Error",
      component: Error,
      props: true
    },
    {
      path: "/icons",
      name: "Icons",
      component: Icons
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js